/**
 * Service: resourceApi
 */
angular.module('acme.common.service.resourceApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion'
])
.service('ResourceApiService', [ '$http', '$q', '$timeout', '$log', 'QueryStringBuilderFactory', 'ApiVersionFactory', function($http, $q, $timeout, $log, QueryStringBuilderFactory, ApiVersionFactory) {

  return {

    init: function(endpoint) {
      var av = new ApiVersionFactory();

      this.service = endpoint + '/resource';
      this.metadata.service = this.service + '/metadata';
      this.field.service = this.service;
      this.instances.service = this.service;
      this.programs.service = this.service;
      this.equipment.service = endpoint + '/equipment';
      this.facilities.service = endpoint + '/facilities';
      this.requests.service = endpoint + '/resource/requests';
      this.available.service = endpoint;
      this.availability.service = av.init({ url: this.service + 's/availability/configurations', version: 'v2' });
      this.assignment.service = endpoint;
      return this;
    },

    service: '',

    /**
     * Gets resource summaries
     *
     * @returns {*}
     */
    list: function(props) {
      var q = '',
          av = new ApiVersionFactory();

      /*
      if (filter) {
        query = '?resourceCategory='+filter;
      }
      console.log('ResourceApiService::list', filter);
      */

      if(props) {
        var qs = new QueryStringBuilderFactory({
          props: props,
          fields: {
            required: ['resourceCategory'],
            optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search']
          }
        });
        q = qs.query;
      }


      return $http({
        method: 'get',
        url:  av.init({ url: this.service + '/type/summaries' + q, version: 'v2' })
      });
    },

    /**
     * Gets resource templates
     *
     * @returns {*}
     */
    templates: function(props) {
      var q = '',
        av = new ApiVersionFactory();

      if(props) {
        var qs = new QueryStringBuilderFactory({
          props: props,
          fields: {
            requires: ['resourceCategory'],
            optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search']
          }
        });
        q = qs.query;
      }

      return $http({
        method: 'get',
        url: av.init({ url: this.service + 'templates' + q, version: 'v2' })
      });
    },

    /**
     * Gets resource templates summaries
     *
     * @returns {*}
     */
    templatesSummaries: function(props) {
      var q = '',
        av = new ApiVersionFactory();

      if(props) {
        var qs = new QueryStringBuilderFactory({
          props: props,
          fields: {
            requires: ['resourceCategory'],
            optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search', 'formId']
          }
        });
        q = qs.query;
      }

      return $http({
        method: 'get',
        url: av.init({ url: this.service + 'templates/summary?' + q, version: 'v2' })
      });
    },

    /**
     * Creates a resource
     *
     * Accepts:
     * {
     *   createdBy : {String},
     *   updatedBy :  {String},
     *   name : {String},
     *   description: {String},
     *   fields: [ //Optional
     *     {
     *       name: {String},
     *       type: {String},
     *       hidden: {String},
     *       stringArrayValue: {Array[{String}...]},
     *       minValue: {Integer},
     *       maxValue: {Integer}
     *     }
     *   ]
     * }
     *
     * @param props
     * @returns {*}
     */
    create: function(props) {

      var av = new ApiVersionFactory();

      return $http({
        method: 'post',
        url: av.init({ url: this.service + 'templates', version: 'v2' }),
        data: {
          name : props.name,
          description: props.description,
          resourceCategory: props.resourceCategory,
          fields: props.fields
        }
      });

    },

    /**
     * Removes a resource template
     *
     * @param id (Integer}
     * @returns {*}
     */
    remove: function(id) {

      return $http({
        method: 'delete',
        url: this.service + '/type/' + id
      });

    },

    /**
     * Gets a single resource
     *
     * @param id {Integer}
     * @returns {*}
     */
    detail: function(id) {

      return $http({
        method: 'get',
        url: this.service + '/type/' + id
      });

    },

    /**
     * Updates a resource template
     *
     * Accepts:
     * {
     *   createdBy : {String},
     *   updatedBy :  {String},
     *   name : {String},
     *   description: {String},
     *   fields: [ //Optional
     *     {
     *       name: {String},
     *       type: {String},
     *       hidden: {String},
     *       stringArrayValue: {Array[{String}...]},
     *       minValue: {Integer},
     *       maxValue: {Integer}
     *     }
     *   ]
     * }
     *
     * @param props
     * @returns {*}
     */
    update: function(props) {
      var av = new ApiVersionFactory();

      return $http({
        method: 'put',
        url: av.init({ url: this.service + '/type/' + props.id, version: 'v2' }),
        data: {
          name : props.name,
          description: props.description,
          resourceCategory: props.resourceCategory,
          fields: props.fields
        }
      });

    },

    metadata: {
      service: '',

      get: function (props) {
        var q = '',
          av = new ApiVersionFactory();
  
        return $http({
          method: 'get',
          url: av.init({
            url: this.service + '/' + props.entityType + '/' + props.entityId ,
            version: 'v2',
          }),
        });
      },

      create: function (props) {
        var av = new ApiVersionFactory();
        
        return $http({
          method: 'post',
          url: av.init({ url: this.service, version: 'v2' }),
          data: {
            entityType: props.entityType,
            entityId: props.entityId,
          },
        });
      },

      delete: function (props) {
        var q = '',
          av = new ApiVersionFactory();
  
        return $http({
          method: 'delete',
          url: av.init({
            url: this.service + '/' + props.onlinePaymentUUID,
            version: 'v2',
          }),
        });
      }
    }, 

    equipment: {

      service: '',

      /**
       * Creates a new facility
       *
       * Accepts:
       * {
       *   name: {String}
       *   description: {String}
       *   capacity: {Number}
       * }
       *
       * @param props
       * @returns {*}
       */
      create: function(props) {
        return $http({
          method: 'post',
          url: this.service,
          data: {
            name: props.name,
            description: props.description
          }
        });
      },

      /**
       * Lists all facilities
       *
       * @returns {*}
       */
      list: function() {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service, version: 'v2' })
        });
      },

      /**
       * Removes facilities
       *
       * @param id
       * @returns {*}
       */
      remove: function(id) {
        return $http({
          method: 'delete',
          url: this.service + '/' + id
        });
      }

    },

    facilities: {

      service: '',

      /**
       * Creates a new facility
       *
       * Accepts:
       * {
       *   name: {String}
       *   description: {String}
       *   capacity: {Number}
       * }
       *
       * @param props
       * @returns {*}
       */
      create: function(props) {
        return $http({
          method: 'post',
          url: this.service,
          data: {
            name: props.name,
            description: props.description,
            capacity: props.capacity
          }
        });
      },

      /**
       * Lists all facilities
       *
       * @returns {*}
       */
      list: function() {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service, version: 'v2' })
        });
      },

      /**
       * Removes facilities
       *
       * @param id
       * @returns {*}
       */
      remove: function(id) {
        return $http({
          method: 'delete',
          url: this.service + '/' + id
        });
      }

    },

    requests: {
      service: '',

      list: function(props) {

        var av = new ApiVersionFactory(),
            qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search', 'eventId', 'ownerId', 'resourceStartTime', 'resourceEndTime', 'eventTemplateId']
              }
            }),
            q = qs.query;

        return $http({
          method: 'get',
          url: av.init({ url: this.service + q, version: 'v2' })
        });

      }
    },

    instances: {

      service: '',

      create: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({ url: this.service + '/instances', version: 'v2' }),
          data: {
            name: props.name,
            fields: props.fields,
            ownerId: props.ownerId,
            description: props.description,
            resourceUser: props.resourceUser,
            resourceTemplateId: props.resourceTemplateId,
            resourceTemplateName: props.resourceTemplateName,
            resourceCategory: props.resourceCategory
          }
        });
      },

      /**
       * Creates an instance of a resource
       *
       *
       * Accepts:
       * {
       *   resourceTemplateId : {Number}
       *   entityIds : {Array{Number}}
       * }
       * @returns {*}
       */
      batchCreate: function(props) {
        return $http({
          method: 'post',
          url: this.service + '/instances/batch',
          data: {
            resourceTemplateId : props.resourceTemplateId,
            entityIds: props.entityIds
          }
        });
      },


      /**
       * Removes an instance of a resource
       *
       *
       * Accepts:
       * {
       *   resourceTemplateId : {Number}
       *   entityIds : {Array{Number}}
       * }
       * @returns {*}
       */
      remove: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'delete',
          url: av.init({ url: this.service + '/instances/' + id, version: 'v2' })
        });
      },

      /**
       * Lists all resource instances by ResourceTemplateId
       *
       * @param id
       * @param props
       * @returns {*}
       */
      list: function(id, props) {
        var data = props,
            av = new ApiVersionFactory();

        if (id) {
          data.resourceTemplateId = id;
        }

        if(props) {
          var qsPage = new QueryStringBuilderFactory({
            props: data,
            fields: {
              requires: ['resourceTemplateId'],
              optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search']
            }
          });
          q = qsPage.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/instances' + q, version: 'v2' })
        });
      },

      /**
       * Lists all resource instances by owner
       *
       * @param props
       * @returns {*}
       */
      ownerList: function(props) {
        var q,
            qs,
            av = new ApiVersionFactory();

        if(props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['ownerId'],
              optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/instances' + q, version: 'v2' })
        });
      },

      /**
       * Filters resource instances by category
       *
       * @param props
       * @returns {*}
       */
      filterList: function(props) {
        var q,
            qs,
            av = new ApiVersionFactory();

        if(props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['category'],
              optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/instances' + q, version: 'v2' })
        });
      },

      /**
       * Lists single resource instance by id
       *
       * @param id
       * @returns {*}
       */
      detail: function(id) {
        return $http({
          method: 'get',
          url: this.service + '/instances/'+id
        });
      },


      /**
       * Updates a resource instance
       *
       * @param props
       * @returns {*}
       */
      update: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'put',
          url:  av.init({ url: this.service + '/instances/' + props.id, version: 'v2' }),
          data: props
        });
      }
    },

    programs: {

      service: '',

      rejection: function() {
        var q;
        q = $q.defer();
        $timeout(function() {
          // Reject promise after return
          q.reject({ data: { error: "Resource ID is required"} });
        }, 100);

        return q.promise;
      },

      list: function(id) {

        var _promise;

        if (!id) {
          _promise = this.rejection();
        }else{
          _promise = $http({
            method: 'get',
            url: this.service + '/type/' + id + '/programs/summary'
          });
        }

        return _promise;

      }

    },

    field: {

      // Initialized by parent init()
      service: '',

      /**
       * Used whenever a promise should be returned but $http module is not used
       *
       * @returns {*|Promise}
       */
      rejection: function() {
        var q;
        q = $q.defer();
        $timeout(function() {
          // Reject promise after return
          q.reject({ data: { error: "Resource ID is required"} });
        }, 100);

        return q.promise;
      },

      /**
       * Remove a field in a resourceTemplate
       *
       * @param name
       * @param id
       * @returns {*}
       */
      remove: function(name, id) {
        var _promise;

        if (!id) {
          _promise = this.rejection();
        }else{
          _promise = $http({
            method: 'delete',
            url: this.service + '/type/' + id + '/fields/' + name
          });
        }

        return _promise;

      },

      /**
       * Updates a field in a resourceTemplate
       *
       * Accepts:
       * {
       *   fieldOrder: {Integer}
       *   name: {String}
       *   type: {String}
       *   stringValue: {String},
       *   stringArrayValue: {Array[{String}...]}
       *   minValue: {Integer}
       *   maxValue: {Integer},
       *   hidden: {Boolean}
       * }
       *
       * @param props
       * @param id
       * @returns {*}
       */
      update: function(props, id) {
        var _promise;

        if (!id) {
          _promise = this.rejection();
        }else{
          _promise = $http({
            method: 'put',
            url: this.service + '/type/' + id + '/fields/' + props.name,
            data: {
              fieldOrder: props.fieldOrder,
              name: props.name,
              type: props.type,
              stringValue: props.stringValue,
              stringArrayValue: props.stringArrayValue,
              minValue: props.minValue,
              maxValue: props.maxValue,
              hidden: props.hidden
            }
          });
        }

        return _promise;
      },

      /**
       * Creates a new field in a resourceTemplate
       *
       * Accepts:
       * {
       *   name: {String}
       *   type: {String}
       *   stringValue: {String},
       *   stringArrayValue: {Array[{String}...]}
       *   minValue: {Integer}
       *   maxValue: {Integer},
       *   hidden: {Boolean}
       * }
       *
       * @param props
       * @param id
       * @returns {*}
       */
      create: function(props, id) {

        var _promise;

        if (!id) {
          _promise = this.rejection();
        }else {

          _promise = $http({
            method: 'post',
            url: this.service + '/type/' + id + '/fields',
            data: {
              fieldOrder: props.fieldOrder,
              name: props.name,
              type: props.type,
              stringValue: props.stringValue,
              stringArrayValue: props.stringArrayValue,
              minValue: props.minValue,
              maxValue: props.maxValue,
              hidden: props.hidden
            }
          });

        }

        return _promise;
      }
    },

    available: {

        service: '',

        /**
         * Requests available resources for an event instance
         *
         * Accepts:
         * {
         *   type: {String}
         *   resourceTemplateId: {String}
         *   resourceId: {String}
         *   fields: {Array[{String}...]}
         *   quantity: {Integer}
         *   resourceCategory: {String}
         * }
         *
         * @param id {eventId}
         * @returns {*}
         */
        event: function(props, id) {
            var _promise;

            if (!id) {
                _promise = this.rejection();
            } else {
                _promise = $http({
                    method: 'post',
                    url: this.service + '/resources/available/event/' + id,
                    data: {
                        type: props.type,
                        resourceTemplateId: props.resourceTemplateId,
                        resourceId: props.resourceId,
                        fields: props.fields,
                        quantity: props.quantity,
                        resourceCategory: props.resourceCategory
                    }
                });
            }

            return _promise;
        }
    },

    availability: {

      service: '',

      create: function(props) {
        return $http({
          method: 'post',
          url: this.service,
          data: {
            entityId: props.entityId,
            resourceCategory: props.resourceCategory,
            available: props.available,
            unavailable: props.unavailable
          }
        });
      },

      update: function(props) {

        return $http({
          method: 'put',
          url: this.service,
          data: {
            id: props.id,
            entityId: props.entityId,
            resourceCategory: props.resourceCategory,
            available: props.available,
            unavailable: props.unavailable
          }
        });
      },

      detail: function(props) {

        if(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['entityId']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: this.service + q
        });
      }

    },

    assignment: {

      service: '',

      event: function(props, event_id) {
          var _promise;

          if (!event_id) {
              _promise = this.rejection();
          } else {
              // Must specify a property if you wish to assign
              if ( props.assign === true && !props.hasOwnProperty('id') ) {
                  _promise = this.rejection();
              } else {
                  var urlParam = '?resourceId=' + props.id;
                  if ( !props.assign ) {
                      urlParam = '?assign=false';
                  }

                  _promise = $http({
                      method: 'post',
                      url: this.service + '/resources/assignment/event/' + event_id + urlParam,
                      data: {
                          type: props.type,
                          resourceTemplateId: props.resourceTemplateId,
                          resourceId: props.resourceId,
                          fields: props.fields,
                          quantity: props.quantity,
                          resourceCategory: props.resourceCategory
                      }
                  });
              }
          }

          return _promise;
      },

      request: function(props) {
        var q,
            qs,
            av = new ApiVersionFactory();

        if(props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['match', 'available'],
              optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search', 'resourceOwnerId', 'startTime', 'durationHour', 'durationMinutes']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/resources/assignment/request/' + props.id + q, version: 'v2' })
        });
      },

      resourceRequestPrivateEvent: function(props) {
        var q,
            qs,
            av = new ApiVersionFactory();

        if(props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['match', 'available'],
              optional: [
                'eventId',
                'eventTemplateId',
                'scheduleId',
                'resourceTemplateId',
                'resourceCategory',
                'startTime', 
                'durationHour', 
                'durationMinutes',
                'search', 
                'page',
                'pageSize', 
                'sortField', 
                'sortDirection'
              ]
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/resources/assignment/request/private/' + props.resourceRequestId + q, version: 'v2' })
        });
      },

      resourceRequest: function(props) {
        var q,
            qs,
            av = new ApiVersionFactory();

        if(props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['match', 'available'],
              optional: [
                'resourceTemplateId',
                'resourceCategory',
                'startTime', 
                'durationHour', 
                'durationMinutes',
                'search', 
                'page',
                'pageSize', 
                'sortField', 
                'sortDirection'
              ]
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/resources/assignment/request' + q, version: 'v2' })
        });
      },

      assign: function(props) {
        var q,
            qs,
            av = new ApiVersionFactory();

        if(props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['resourceOwnerId']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'post',
          url: av.init({ url: this.service + '/resources/assignment/request/' + props.resourceRequestId + q, version: 'v2' }),
          data: {
            resourceId: props.resourceId,
            assign: true,
            sendEmail: props.sendEmail
          }
        });
      },

      unassign: function(props) {
        var q,
            qs,
            av = new ApiVersionFactory();

        if(props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['resourceOwnerId']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'post',
          url: av.init({ url: this.service + '/resources/assignment/request/' + props.resourceRequestId + q, version: 'v2' }),
          data: {
            resourceId: props.resourceId,
            assign: false,
            sendEmail: props.sendEmail
          }
        });
      }

    }
  };

}]);